import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { IInitialDataState } from './state';

const state = (state: AppState) => state.initialDataState;

export const initialData_Form = createSelector(
  state,
  (state: IInitialDataState) => state.form
);
export const initialData_DataSaved = createSelector(
  state,
  (state: IInitialDataState) => state.dataSaved
);